// src/components/HomePageComponents/HomeSectionFive.jsx
import React from "react";
import { Box, Container, Stack, Typography, Button } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { FONT_WEIGHT } from '../../theme/fonts';

export default function HomeSectionFive() {
  return (
    <Box
      id="section5"
      sx={{
        scrollMarginTop: "72px",
        py: { xs: 6, md: 8 },
        bgcolor: '#f8f9fa',
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            px: { xs: 3, md: 4 },
            py: { xs: 3.5, md: 4 },
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "#fff",
          }}
        >
          <Stack spacing={2} alignItems="center" textAlign="center">
            <Typography variant="h6" sx={{ fontWeight: FONT_WEIGHT.bold }}>
              Stay in the loop
            </Typography>

            <Typography variant="body1" sx={{ maxWidth: 680, color: '#000' }}>
              Follow CivixThread on LinkedIn for release notes and behind-the-scenes updates.
            </Typography>

            <Button
              component="a"
              href="https://www.linkedin.com/company/civixthread/"
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              startIcon={<LinkedInIcon />}
              sx={{
                mt: 0.5,
                textTransform: "none",
                fontWeight: FONT_WEIGHT.semibold,
                borderRadius: 3,
                px: 2.75,
                py: 1,
                background: `linear-gradient(135deg, #047857 0%, #059669 50%, #047857 100%)`,
                "&:hover": {
                  background: `linear-gradient(135deg, #065f46 0%, #047857 50%, #065f46 100%)`,
                },
              }}
            >
              Follow on LinkedIn
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
